import type { CollectDataTemplateStepRow } from 'src/interfaces/onboardingTemplate'
import type { OnboardingTemplateStep } from 'src/interfaces/onboardingTemplate'
import { editorStepToApiRow } from 'src/utils/collectDataTemplateEditor/stepApiMapping'
import type { FlowEditorConfigDraft, FlowEditorStepDraft } from './types'

export function draftStepToEditorStep(
  step: FlowEditorStepDraft,
  configLocalId: string,
): OnboardingTemplateStep {
  return {
    id: step.localId,
    type: step.type,
    order: step.order,
    retroactiveCollectRequired: step.retroactiveCollectRequired,
    ignoreMonitoring: step.ignoreMonitoring,
    recollectSameTypeSteps: step.recollectSameTypeSteps,
    skipRetroactiveCollectIfAnySameTypeCompleted: step.skipRetroactiveCollectIfAnySameTypeCompleted,
    collectDataTemplateStepsConfigId: configLocalId,
    collectDataTemplateStepLabel: step.collectDataTemplateStepLabel,
    config: step.config,
  }
}

export function draftStepToApiRow(
  step: FlowEditorStepDraft,
  config: FlowEditorConfigDraft,
  templateId: string,
): CollectDataTemplateStepRow {
  const editorStep = draftStepToEditorStep(step, config.localId)
  const configIdForRow = config.serverId ?? config.localId

  return editorStepToApiRow(editorStep, step.order, templateId, configIdForRow)
}
